<div class="flex flex-row justify-between items-center">
  <app-reports-summary-header [totals]="totals()"></app-reports-summary-header>
  <app-report-actions [request]="reportRequest()"
                      [downloadFn]="downloadDetailedReport">
  ></app-report-actions>
</div>
<p-divider />
<app-detailed-report-table
  [isOwner]="isOwner()"
  [data]="tableData()"></app-detailed-report-table>
